import { SagaIterator } from 'redux-saga';
import { takeLatest } from 'redux-saga/effects';
import { keyPhraseGroupIsExistSaga } from 'src/react/keyPhraseGroup/sagas/keyPhraseGroupIsExistSaga';
import { KEY_PHRASE_GROUP_IS_EXIST_ACTIONS } from 'src/react/keyPhraseGroup/actions/keyPhraseGroupIsExistActions';

export function* keyPhraseGroupSaga(): SagaIterator {
    yield takeLatest(KEY_PHRASE_GROUP_IS_EXIST_ACTIONS.REQUEST, keyPhraseGroupIsExistSaga);
}
